/**
 * <s-tracking-form> — Sends a shopper to the courier's tracking page for the AWB they enter.
 *
 * Attributes (on <s-tracking-form>):
 *   data-tracking-url — Courier URL with an `{awb}` token, e.g. https://www.delhivery.com/track-v2/package/{awb}
 *
 * Required child markup:
 *   form                 — Submitting it opens the tracking page in a new tab.
 *   input[name="awb"]    — The tracking number field.
 *   [data-tracking-error] — Element shown with an error message when the field is empty or invalid.
 */
class TrackingForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.input = this.querySelector('input[name="awb"]');
    this.error = this.querySelector('[data-tracking-error]');
    if (!this.form || !this.input) return;

    this.onSubmit = this.onSubmit.bind(this);
    this.onInput = this.onInput.bind(this);
    this.form.addEventListener('submit', this.onSubmit);
    this.input.addEventListener('input', this.onInput);
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.onSubmit);
    this.input?.removeEventListener('input', this.onInput);
  }

  onInput() {
    this.setError(false);
  }

  onSubmit(event) {
    event.preventDefault();
    const awb = this.input.value.replace(/[\s-]/g, '');
    const template = this.dataset.trackingUrl || '';

    if (!/^[A-Za-z0-9]{6,30}$/.test(awb) || !template.includes('{awb}')) {
      this.setError(true);
      this.input.focus();
      return;
    }

    const url = template.replace('{awb}', encodeURIComponent(awb));
    const opened = window.open(url, '_blank', 'noopener');
    if (!opened) window.location.href = url;
  }

  setError(show) {
    if (!this.error) return;
    this.error.hidden = !show;
    if (show) {
      this.input.setAttribute('aria-invalid', 'true');
    } else {
      this.input.removeAttribute('aria-invalid');
    }
  }
}

if (!customElements.get('s-tracking-form')) {
  customElements.define('s-tracking-form', TrackingForm);
}
